export const themes = [{value: 'light', name: 'Light'}, {value: 'dark', name: 'Dark'}];